module.exports = __webpack_public_path__ + "static/media/28.bc3fe5e9.jpg";